<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { primary200 } = $AppState.theme.colors;
</script>

<svg
  width="25"
  height="24"
  viewBox="0 0 25 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_409_17643)">
    <path
      d="M23.5 3.00029C22.5424 3.67577 21.4821 4.1924 20.36 4.53029C19.7577 3.8378 18.9573 3.34698 18.067 3.12422C17.1767 2.90145 16.2395 2.95749 15.3821 3.28474C14.5247 3.612 13.7884 4.19469 13.273 4.95401C12.7575 5.71332 12.4877 6.61263 12.5 7.53029V8.53029C10.7426 8.57586 9.00127 8.1861 7.43101 7.39574C5.86074 6.60537 4.51032 5.43893 3.5 4.00029C3.5 4.00029 -0.5 13.0003 8.5 17.0003C6.44053 18.3983 3.98716 19.0992 1.5 19.0003C10.5 24.0003 21.5 19.0003 21.5 7.50029C21.4991 7.22174 21.4723 6.94389 21.42 6.67029C22.4406 5.66378 23.1608 4.393 23.5 3.00029Z"
      stroke={primary200}
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <clipPath id="clip0_409_17643">
      <rect width="24" height="24" fill="white" transform="translate(0.5)" />
    </clipPath>
  </defs>
</svg>
